import React from 'react';
import { Field, useFormikContext } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';

const SuperProfileWorkCategoryInput = () => {
  const { setFieldValue } = useFormikContext();

  const workCategoryOptions = [
    {
      label: 'Information Technology',
      value: 'INFORMATION_TECHNOLOGY',
    },
    {
      label: 'Technical and Mechanical',
      value: 'TECHNICAL_AND_MECHANICAL',
    },
    {
      label: 'Trade and Service',
      value: 'TRADE_AND_SERVICE',
    },
    {
      label: 'Industry and Craft',
      value: 'INDUSTRY_AND_CRAFT',
    },
    {
      label: 'Healthcare, Medical and Social',
      value: 'HEALTHCARE_MEDICAL_AND_SOCIAL',
    },
    {
      label: 'Sales, Marketing and Communication',
      value: 'SALES_MARKETING_AND_COMMUNICATION',
    },
    {
      label: 'Education and Research',
      value: 'EDUCATION_AND_RESEARCH',
    },
    {
      label: 'Office and Economy',
      value: 'OFFICE_AND_ECONOMY',
    },
    {
      label: 'Other',
      value: 'OTHER',
    },
  ];

  return (
    <div className="p-col-12 ">
      <div className="flex-space-between">
        <FormattedMessage id="account.super-profiles.new.work-category" defaultMessage="Work category">
          {(text) => (
            <label className="field-label" htmlFor="workCategory">
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              id="workCategory"
              name="workCategory"
              component={DropdownComponent}
              options={workCategoryOptions}
              filter
              filterBy="label,value"
              className="right"
              onChange={(event) => {
                setFieldValue('workCategory', event.value);
              }}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileWorkCategoryInput;
